import styled, { css } from "styled-components"
const overlayStyles = css`
	background-color: rgba(0, 0, 0, 0.5);
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 999999;
	display: flex;
	justify-content: center;
	align-items: center;
`
const commonPopUpStyle = css`
	padding: 24px;
	border-radius: 8px;
	background-color: #fff;
	width: 60%;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
`
export const DisableWheelHouseWrapper = styled.div`
	${overlayStyles}
	> div {
		${commonPopUpStyle}
		position: relative;
		div {
			&:nth-child(1) {
				position: absolute;
				top: 10px;
				left: 10px;
				width: 20px;
				height: 20px;
				cursor: pointer;
			}
			&:nth-child(2) {
				width: 50px;
				height: 66px;
				svg {
					width: 100%;
					height: 100%;
				}
			}
			&:nth-child(3) {
				font-weight: 700;
				font-size: 18px;
				line-height: 28px;
				letter-spacing: 0%;
				margin-bottom: 32px;
			}
			&:nth-child(4) {
			}
		}
	}
`
export const ApplyWheelHouseWrapper = styled.div`
	${overlayStyles}
	> div {
		${commonPopUpStyle}
		position: relative;
		div {
			&:nth-child(1) {
				position: absolute;
				top: 10px;
				left: 10px;
				width: 20px;
				height: 20px;
				cursor: pointer;
			}
			&:nth-child(2) {
				width: 50px;
				height: 66px;
				svg {
					width: 100%;
					height: 100%;
				}
			}
			&:nth-child(3) {
				font-weight: 700;
				font-size: 18px;
				line-height: 28px;
				letter-spacing: 0%;
				margin-bottom: 32px;
			}
			&:nth-child(4) {
			}
		}
	}
`

export const SettingsPropertiesWrapper = styled.div`
	width: 100%;
	position: absolute;
	top: 75px;
	z-index: 999;
	border-radius: 8px;
	padding: 16px;
	background-color: #fff;
	box-shadow: 0px 4px 34px 0px #0000001a;
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: auto 1fr;
	form {
		display: grid;
		grid-template-columns: 1fr;
		grid-template-rows: 1fr auto;
		height: 100%;
		gap: 8px;
		.containerSearchInput {
		}
		.displayRes {
			overflow-y: scroll;
			.continerRecord {
				display: grid;
				grid-template-columns: 1fr auto;
				grid-template-rows: 1fr;
				gap: 8px;
				.containerInfo {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					gap: 16px;
					.containerChannels {
						display: flex;
						justify-content: flex-start;
						align-items: center;
					}
				}
			}
		}
		.containerFooter {
			display: flex;
			justify-content: flex-end;
			gap: 16px;
		}
	}
`

export const AreProAccountWrapper = styled(DisableWheelHouseWrapper)``
